<template>
  <div class="abiturient-parent-children-list">
    <v-row>
      <v-breadcrumbs
        :items="breadcrumbs"
        divider="/"
        class="mb-4"
      ></v-breadcrumbs>
    </v-row>
    <v-card outlined class="pa-6 child-select-card">
      <v-select
        v-model="selectedChildIin"
        :items="eligibleChildren"
        item-text="fullName"
        item-value="iin"
        :label="$t('Выберите детей')"
        :no-data-text="$t('Данные о детях, достигших выпускного возраста, отсутствуют в базе.')"
        :rules="[(v) => !!v || $t('Обязательное поле')]"
      ></v-select>
      <div class="text-right mt-4">
        <v-btn text class="mr-3" to="/abiturient/my-requests/new">{{
          $t('Назад')
        }}</v-btn>
        <v-btn
          color="primary"
          :disabled="!selectedChildIin"
          @click="continueToForm"
        >
          {{ $t('Продолжить') }}
        </v-btn>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  data: () => ({
    selectedChildIin: null,
  }),
  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t('Главная'),
          disabled: false,
          exact: true,
          to: '/abiturient',
        },
        {
          text: this.$t('Мои заявки'),
          disabled: false,
          exact: true,
          to: '/abiturient/my-requests',
        },
        {
          text: this.$t('Выбор ребёнка'),
          disabled: true,
          exact: true,
          to: '',
        },
      ]
    },
    eligibleChildren() {
      const data = Array.isArray(this.$store.state.gbdflData)
        ? this.$store.state.gbdflData
        : []
      return data
        .filter((child) => this.calculateAge(child.birthday) >= 16)
        .map((child) => ({
          ...child,
          fullName: `${child.surname || ''} ${child.name || ''} ${
            child.patronymic || ''
          }`.trim(),
        }))
    },
  },
  methods: {
    continueToForm() {
      const child = this.eligibleChildren.find(
        (c) => c.iin === this.selectedChildIin,
      )
      if (!child) return
      this.$store.dispatch('setSelectedChild', child)
      this.$router.push('/abiturient/my-requests/parent')
    },
    calculateAge(birthday) {
      const birthDate = new Date(birthday)
      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      const m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    },
  },
}
</script>

<style scoped src="@/assets/css/abiturient/ParentChildrenListView.css"></style>
